export default __webpack_public_path__ + "static/media/glossary_check_excel_en.18481623.png";